export default __webpack_public_path__ + "assets/apple-touch-icon-84x84-b794edf.png";